<svelte:options customElement="clw-icon-lock" />

<script lang="ts">
    let className = '';
    export { className as class };
    export let fillColor = 'white';
</script>

<svg width="100%" height="100%" viewBox="0 0 24 22.588" fill="none" xmlns="http://www.w3.org/2000/svg" class={className}
    ><path
        d="M17.356 8.188h-0.944V5.647s0 -4.235 -4.412 -4.235 -4.412 4.235 -4.412 4.235v2.541h-0.944c-0.452 0 -0.884 0.172 -1.204 0.48a1.602 1.602 0 0 0 -0.498 1.155v6.904c0.003 0.432 0.184 0.847 0.503 1.151 0.319 0.305 0.75 0.476 1.2 0.476h10.712c0.452 0 0.885 -0.172 1.204 -0.48 0.319 -0.305 0.498 -0.72 0.498 -1.155V9.823c0 -0.433 -0.179 -0.85 -0.498 -1.156a1.739 1.739 0 0 0 -1.204 -0.479ZM12 14.965c-0.349 0 -0.69 -0.099 -0.98 -0.285a1.711 1.711 0 0 1 -0.649 -0.761c-0.134 -0.309 -0.169 -0.649 -0.102 -0.978 0.068 -0.329 0.236 -0.631 0.483 -0.868 0.247 -0.236 0.562 -0.398 0.904 -0.463 0.343 -0.065 0.697 -0.031 1.019 0.096 0.323 0.128 0.599 0.346 0.792 0.624a1.646 1.646 0 0 1 -0.219 2.139 1.803 1.803 0 0 1 -1.248 0.497Zm2.647 -6.776h-5.294V6.071c0 -1.271 0 -2.965 2.647 -2.965s2.647 1.694 2.647 2.965v2.118Z"
        fill={fillColor}
    /></svg
>
